(() => {
  if (window.__tmpProductCardDirectAddReady) return;
  window.__tmpProductCardDirectAddReady = true;

  const cartAddUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root.replace(/\/?$/, '/') }cart/add.js`;
  };

  const showAddedFeedback = (button) => {
    const card = button.closest('.product-card');
    const cartButton = document.querySelector('.cart-drawer-button');

    button.classList.add('tmp-is-added');
    card?.classList.add('tmp-added-feedback');
    cartButton?.classList.add('tmp-cart-pulse');

    window.setTimeout(() => {
      button.classList.remove('tmp-is-added');
      card?.classList.remove('tmp-added-feedback');
    }, 1450);

    window.setTimeout(() => {
      cartButton?.classList.remove('tmp-cart-pulse');
    }, 520);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('body.index-template .tmp-home-product-row .tmp-product-card-direct-add, .collection-section #ProductsList .tmp-product-card-direct-add, .section--related-products .tmp-product-card-direct-add, #CartDrawer .tmp-empty-cart-card .tmp-product-card-direct-add');
    if (!button || button.disabled || button.dataset.tmpBusy === 'true') return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const variantId = button.dataset.variantId || form.querySelector('input[name="id"]')?.value;
    if (!variantId) return;

    button.dataset.tmpBusy = 'true';
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');

    try {
      const payload = new FormData(form);
      payload.set('id', variantId);
      payload.set('quantity', '1');

      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: payload
      });

      const addedProduct = await response.json();

      if (!response.ok) {
        throw new Error(addedProduct?.description || addedProduct?.message || 'Could not add this product to the cart.');
      }

      showAddedFeedback(button);

      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        detail: { product: addedProduct }
      }));
      const keepDrawerOpen = Boolean(button.closest('#CartDrawer'));
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { open: keepDrawerOpen }
      }));
    } catch (error) {
      console.error('[TMP quick add]', error);
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-busy');
      delete button.dataset.tmpBusy;
    }
  }, true);
})();

/* TMP desktop polish: persistent quick-add, round Trustpilot arrows, no account icon. */
(() => {
  const STYLE_ID = 'TmpDesktopPolish';
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    @media (min-width:1024px){
      body .product-card .product-card__image-wrapper .product-card__actions.product-card__main-actions,
      body .product-card .product-card__image-wrapper form.product-card__actions.product-card__main-actions{
        display:flex!important;
        opacity:1!important;
        visibility:visible!important;
        transform:none!important;
        pointer-events:auto!important;
      }
      body .product-card .product-card__image-wrapper .product-card__actions.product-card__main-actions .product-card__atc{
        display:inline-flex!important;
        opacity:1!important;
        visibility:visible!important;
        transform:none!important;
        pointer-events:auto!important;
      }
      body .product-card .product-card__image-wrapper .product-card__actions.product-card__main-actions .product-card__atc-icon{
        display:inline-flex!important;
        opacity:1!important;
        visibility:visible!important;
      }
      body .product-card .product-card__image-wrapper .product-card__actions.product-card__main-actions .product-card__atc-text{
        display:none!important;
      }
      body .header__icons--right .header__account{
        display:none!important;
      }
      body .tmp-trust__arrow{
        display:inline-flex!important;
        align-items:center!important;
        justify-content:center!important;
        flex:0 0 34px!important;
        width:34px!important;
        min-width:34px!important;
        max-width:34px!important;
        height:34px!important;
        min-height:34px!important;
        max-height:34px!important;
        padding:0!important;
        margin:0!important;
        aspect-ratio:1/1!important;
        box-sizing:border-box!important;
        border-radius:999px!important;
        line-height:1!important;
        white-space:nowrap!important;
        text-indent:0!important;
        overflow:hidden!important;
      }
    }
  `;
  document.head.appendChild(style);
})();

/* TMP product-page Trustpilot: reuse the exact homepage widget under related products on desktop. */
(() => {
  if (window.__tmpProductTrustFromHomeReady) return;
  window.__tmpProductTrustFromHomeReady = true;

  const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;

  const initTrustSlider = (wrapper) => {
    const root = wrapper?.querySelector('[data-tmp-trust]');
    if (!root || root.dataset.tmpProductTrustInitialized === 'true') return;
    root.dataset.tmpProductTrustInitialized = 'true';

    const rail = root.querySelector('[data-trust-rail]');
    const prev = root.querySelector('[data-trust-prev]');
    const next = root.querySelector('[data-trust-next]');
    if (!rail) return;

    const getStep = () => {
      const card = rail.querySelector('.tmp-trust__card');
      if (!card) return rail.clientWidth * .8;
      const styles = getComputedStyle(rail);
      return card.getBoundingClientRect().width + parseFloat(styles.gap || 0);
    };

    if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -getStep(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => rail.scrollBy({ left: getStep(), behavior: 'smooth' }));

    const autoplay = root.dataset.autoplay === 'true';
    const speed = Math.max(3, parseInt(root.dataset.autoplaySpeed || '5', 10)) * 1000;
    if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const timer = window.setInterval(() => {
        if (!document.documentElement.contains(root)) {
          window.clearInterval(timer);
          return;
        }
        const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
        rail.scrollTo({ left: atEnd ? 0 : rail.scrollLeft + getStep(), behavior: 'smooth' });
      }, speed);
    }
  };

  const mount = async () => {
    if (!isDesktop()) return;
    if (document.querySelector('[data-tmp-product-trust-from-home]')) return;

    const related = document.querySelector('.section--related-products');
    if (!related) return;
    const relatedSection = related.closest('.shopify-section') || related;

    try {
      const sectionUrl = new URL('/', window.location.origin);
      sectionUrl.searchParams.set('section_id', 'trust_slider_Gtp93z');
      const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewThemeId) sectionUrl.searchParams.set('preview_theme_id', previewThemeId);

      const response = await fetch(sectionUrl.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('Could not load homepage Trustpilot section.');

      const html = await response.text();
      const holder = document.createElement('div');
      holder.innerHTML = html.trim();
      const source = holder.querySelector('.tmp-trust-section, [id^="shopify-section-trust_slider_Gtp93z"]') || holder.firstElementChild;
      if (!source || !source.querySelector('[data-tmp-trust]')) throw new Error('Homepage Trustpilot section was not found.');

      source.querySelectorAll('script').forEach((script) => script.remove());
      source.setAttribute('data-tmp-product-trust-from-home', 'true');
      relatedSection.insertAdjacentElement('afterend', source);
      initTrustSlider(source);
    } catch (error) {
      console.error('[TMP homepage Trustpilot copy]', error);
    }
  };

  const scheduleMount = () => requestAnimationFrame(mount);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMount, { once: true });
  } else {
    scheduleMount();
  }

  new MutationObserver(() => {
    if (!document.querySelector('[data-tmp-product-trust-from-home]')) scheduleMount();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();


/* TMP product-page ATC = homepage behaviour 2026-09-27 */
(() => {
  if (window.__tmpProductPageDirectAddReady) return;
  window.__tmpProductPageDirectAddReady = true;

  const cartAddUrl = () => {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return `${root.replace(/\/?$/, '/') }cart/add.js`;
  };

  const setAddedFeedback = (button) => {
    if (!button) return;
    const label = button.querySelector(':scope > span') || button.querySelector('span');
    if (label && !button.dataset.tmpOriginalLabel) {
      button.dataset.tmpOriginalLabel = label.textContent.trim();
    }

    button.classList.add('tmp-pdp-is-added');
    if (label) label.textContent = 'ADDED';

    const cartButton = document.querySelector('.cart-drawer-button');
    cartButton?.classList.add('tmp-cart-pulse');

    window.setTimeout(() => {
      button.classList.remove('tmp-pdp-is-added');
      if (label && button.dataset.tmpOriginalLabel) {
        label.textContent = button.dataset.tmpOriginalLabel;
      }
    }, 1450);

    window.setTimeout(() => {
      cartButton?.classList.remove('tmp-cart-pulse');
    }, 520);
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('form.main-product-form[data-type="add-to-cart-form"], form.sticky-atc-bar__form[data-type="add-to-cart-form"]');
    if (!form || form.closest('#CartDrawer') || form.closest('quick-view')) return;

    const button = form.querySelector('button[name="add"][type="submit"]');
    if (!button || button.disabled || button.dataset.tmpBusy === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    button.dataset.tmpBusy = 'true';
    button.setAttribute('aria-busy', 'true');
    button.classList.add('btn--loading');

    try {
      const formData = new FormData(form);
      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });

      const addedProduct = await response.json();

      if (!response.ok) {
        throw new Error(addedProduct?.description || addedProduct?.message || 'Could not add this product to the cart.');
      }

      setAddedFeedback(button);

      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        detail: { product: addedProduct }
      }));

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: { open: false }
      }));
    } catch (error) {
      console.error('[TMP PDP add to cart]', error);
      const errorBox = form.closest('.product-form')?.querySelector('.product-form__error-message');
      if (errorBox) {
        errorBox.hidden = false;
        errorBox.textContent = error?.message || 'Could not add this product to the cart.';
      }
    } finally {
      button.classList.remove('btn--loading');
      button.removeAttribute('aria-busy');
      delete button.dataset.tmpBusy;
    }
  }, true);
})();
